/**
 * Route for `igaming-cross-brand-player-de-duplication`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingCrossBrandPlayerDeDuplicationPage } from "../features/igaming-cross-brand-player-de-duplication/IgamingCrossBrandPlayerDeDuplicationPage";

export const igamingCrossBrandPlayerDeDuplicationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-cross-brand-player-de-duplication",
	component: IgamingCrossBrandPlayerDeDuplicationPage,
});

export default igamingCrossBrandPlayerDeDuplicationRoute;
